import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-cdc45a36")
const _hoisted_1 = {
  key: 0,
  class: "spinner_contaier"
}
const _hoisted_2 = {
  key: 1,
  class: "p-d-flex p-flex-column p-jc-center"
}
const _hoisted_3 = { class: "p-field p-fluid" }
const _hoisted_4 = { class: "p-d-flex p-flex-column p-jc-center" }
const _hoisted_5 = { class: "p-field p-fluid" }
const _hoisted_6 = { class: "p-d-flex p-flex-column p-jc-center" }
const _hoisted_7 = { class: "p-field p-fluid" }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Hours: ")
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "p-field p-fluid" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "cycles" }, "Cycles", -1)
const _hoisted_14 = { class: "p-field p-fluid" }
const _hoisted_15 = { class: "p-d-flex p-flex-column p-jc-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "Calculated Fee", -1)
const _hoisted_17 = { class: "p-field p-fluid" }
const _hoisted_18 = { class: "p-d-flex p-flex-column p-jc-center" }
const _hoisted_19 = { class: "p-field p-fluid" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_MomentZoneCalendar = _resolveComponent("MomentZoneCalendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, _mergeProps({
    "dismissable-mask": "",
    modal: ""
  }, _ctx.$attrs, { onShow: _ctx.onShow }), {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Cancel",
        class: "p-button-info",
        onClick: _ctx.onCancel,
        disabled: _ctx.requestPending,
        icon: "pi pi-times"
      }, null, 8, ["onClick", "disabled"]),
      _createVNode(_component_Button, {
        label: "Confirm",
        onClick: _ctx.onConfirm,
        disabled: _ctx.requestPending,
        icon: "pi pi-check"
      }, null, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      (_ctx.requestPending)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ProgressSpinner)
          ]))
        : _createCommentVNode("", true),
      (_ctx.ttCopy.dispute_note)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_FloatLabel, { label: "Dispute note" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Textarea, {
                    readonly: true,
                    autoresize: true,
                    modelValue: _ctx.ttCopy.dispute_note,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.ttCopy.dispute_note = $event)),
                    rows: 10
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FloatLabel, { label: "Start time" }, {
            default: _withCtx(() => [
              _createVNode(_component_MomentZoneCalendar, {
                timezone: _ctx.ttCopy.zone_name,
                moment: _ctx.ttCopy.datetime_start,
                "onUpdate:moment": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.ttCopy.datetime_start = $event)),
                  _ctx.calcFee
                ],
                disabled: _ctx.requestPending || !_ctx.canEdit,
                max: _ctx.ttCopy.datetime_end
              }, null, 8, ["timezone", "moment", "disabled", "max", "onUpdate:moment"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FloatLabel, { label: "End time" }, {
            default: _withCtx(() => [
              _createVNode(_component_MomentZoneCalendar, {
                timezone: _ctx.ttCopy.zone_name,
                min: _ctx.ttCopy.datetime_start,
                disabled: _ctx.requestPending || !_ctx.canEdit,
                moment: _ctx.ttCopy.datetime_end,
                "onUpdate:moment": [
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.ttCopy.datetime_end = $event)),
                  _ctx.calcFee
                ]
              }, null, 8, ["timezone", "min", "disabled", "moment", "onUpdate:moment"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        (_ctx.hasEndDate)
          ? (_openBlock(), _createElementBlock("i", _hoisted_10, "(" + _toDisplayString(_ctx.duration) + ")", 1))
          : (_openBlock(), _createElementBlock("i", _hoisted_11, "In progress (" + _toDisplayString(_ctx.duration) + ")", 1))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_InputNumber, {
          inputId: "cycles",
          modelValue: _ctx.cycles,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cycles = $event)),
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeInputNumber($event, 'cycles'))),
          showButtons: "",
          disabled: _ctx.requestPending || !_ctx.canEdit,
          buttonLayout: "horizontal",
          step: 1,
          decrementButtonClass: "p-button-danger",
          incrementButtonClass: "p-button-success",
          incrementButtonIcon: "pi pi-plus",
          decrementButtonIcon: "pi pi-minus"
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('ticket.total_ton')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputNumber, {
              modelValue: _ctx.ttCopy.total_ton,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.ttCopy.total_ton = $event)),
              mode: "decimal",
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeInputNumber($event, 'total_ton'))),
              disabled: _ctx.requestPending || !_ctx.canEdit,
              minFractionDigits: 1
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_InputNumber, {
            modelValue: _ctx.calculatedFee,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.calculatedFee = $event)),
            mode: "currency",
            currency: "USD",
            locale: "en-US",
            disabled: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_FloatLabel, { label: "Finish note" }, {
            default: _withCtx(() => [
              _createVNode(_component_Textarea, {
                modelValue: _ctx.ttCopy.finish_note,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.ttCopy.finish_note = $event)),
                placeholder: "Enter finish note"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 16, ["onShow"]))
}